/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const UserRoleDto = {
    Admin: 'ADMIN',
    Owner: 'OWNER',
    ManagingDirector: 'MANAGING_DIRECTOR',
    Accounting: 'ACCOUNTING',
    SalesManagerDirector: 'SALES_MANAGER_DIRECTOR',
    DevelopmentDirector: 'DEVELOPMENT_DIRECTOR',
    SalesDepartment: 'SALES_DEPARTMENT',
    ImplementationDepartment: 'IMPLEMENTATION_DEPARTMENT',
    LogisticsDepartment: 'LOGISTICS_DEPARTMENT',
    EquipmentDepartment: 'EQUIPMENT_DEPARTMENT',
    GoodsDepartment: 'GOODS_DEPARTMENT',
    MarketingDepartment: 'MARKETING_DEPARTMENT',
    Kitchen: 'KITCHEN',
    Confectionery: 'CONFECTIONERY',
    DecoratorsStudio: 'DECORATORS_STUDIO',
} as const;

export type UserRoleDto = typeof UserRoleDto[keyof typeof UserRoleDto];



